<template><div></div></template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "MicrosofCallback",

  data: () => ({
    query: {},
  }),

  computed: {
    ...mapGetters(["token", "appBaseUrl", "nextPage"]),
  },

  methods: {
    ...mapMutations([
      "setToken",
      "setCurrentUser",
      "setCompany",
      "setTrialIsAllowed",
      "setAuthError",
    ]),

    ...mapActions(["syncUsersAsync", "getContractedPlans"]),

    async loginMicrosoft() {
      const params = Object.assign({}, this.$route.query);
      this.$router.replace({ query: null });

      if (!Object.keys(params).length) {
        this.pushHomeOrNextPage();
      }

      const url = `${process.env.VUE_APP_API_BASE_URL}/auth/callback/ms`;

      const payload = {
        callback_url: `${this.appBaseUrl}/auth/callback/microsoft`,
      };

      params.allow_trial = localStorage.getItem("allow_trial") || "not_allowed";

      if (!this.$store.state.hutk) {
        await this.$store.dispatch("fetchHutk");
      }
      params.hutk = this.$store.state.hutk;

      return this.$axios
        .post(url, payload, { params })
        .then(({ data }) => {
          localStorage.setItem("companyOauth", data.company.oauth);
          this.setToken(data.token);
          this.setCurrentUser(data.user);
          this.setCompany(data.company);
          this.setTrialIsAllowed(data.trialIsAllowed);
          this.syncUsersAsync();
          this.getContractedPlans();
          this.pushHomeOrNextPage();
        })
        .catch((error) => {
          console.error("loginMicrosoft(): ", error);
          const { code } = error?.response?.data || {};
          if (code) {
            this.setAuthError(code);
          } else {
            this.setAuthError("UNKNOWN_ERROR");
          }
          this.pushHomeOrNextPage();
        })
        .finally(() => {
          this.loadingAuthentication = false;
        });
    },

    pushHomeOrNextPage() {
      if (this.nextPage) {
        this.$router.push(this.nextPage);
        localStorage.removeItem("nextPage");
      } else {
        this.$router.push({ name: "Home" });
      }
    },
  },

  mounted() {
    this.loginMicrosoft();
  },
};
</script>
